import { useEffect, useState } from 'react';
import { MOBILE_BREAKPOINT } from '../../../constants/componentStaticData';
import { DefaultMeta } from '../../../types/partner-page-types';
import { If } from '../../Atoms/Conditionals';
import { useViewport } from '../../hooks';
import { PlanCarousal } from '../page-sections/eas-section/expertPlans/planCarousal';
import { PriceCard } from '../price_cards/price_cards';
import { IPartnerPlanData } from '../types';

interface ICardsMobileCarousel {
  cardData: IPartnerPlanData[];
  metaData: DefaultMeta;
  showPlanFooter?: boolean;
  alwaysCarousel?: boolean;
  autoplay?: boolean;
  infinite?: boolean;
  customInfinite?: boolean;
  background?: 'white' | 'grey';
}

export const CardsMobileCarousel: React.FC<ICardsMobileCarousel> = ({
  cardData,
  metaData,
  showPlanFooter = false,
  alwaysCarousel = false,
  autoplay = true,
  infinite = true,
  customInfinite = false,
  background = 'white',
}): JSX.Element => {
  const [windowWidth, setWidth] = useState(1024);
  const { width } = useViewport();
  const isMobile = windowWidth && windowWidth < MOBILE_BREAKPOINT;
  const bgClass =
    background === 'white'
      ? 'custom-overflow-bg-white'
      : 'custom-overflow-bg-grey';

  useEffect(() => {
    const { innerWidth: widthValue } = window;
    setWidth(widthValue);
  }, [width]);

  if (isMobile && cardData.length > 3 && !alwaysCarousel) {
    return (
      <PlanCarousal
        plansData={cardData}
        showPlanFooter={showPlanFooter}
        metaData={metaData}
        autoplay={false}
        infinite={infinite}
        customInfinite={customInfinite}
        className={`custom-overflow cards-custom-margin ${bgClass}`}
      />
    );
  }

  if (isMobile && !alwaysCarousel) {
    return (
      <>
        {cardData.map((item, id) => (
          <If condition={!!item} key={id}>
            <PriceCard
              cardData={item}
              metaData={metaData}
              showPlanFooter={showPlanFooter}
            />
          </If>
        ))}
      </>
    );
  }

  return (
    <PlanCarousal
      plansData={cardData}
      showPlanFooter={showPlanFooter}
      metaData={metaData}
      autoplay={autoplay}
      infinite={infinite}
      customInfinite={customInfinite}
      className={`custom-overflow cards-custom-margin ${bgClass}`}
    />
  );
};
